<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap pa-3>
      <v-flex lg4 sm12 py-0>
        <v-autocomplete
          v-if="currentItem.ID == 0"
          label="Mã bao hàng"
          class="input-group--focused pt-0"
          :items="packages"
          v-model="currentItem.ID"
          item-text="PackageCode"
          item-value="ID"
          :disabled="readOnly"
          :rules="[(v) => !!v || 'Hãy nhập mã bao hàng']"
          @change="onChangePackage"
        >
          <template slot="no-data">
            <div>Không có dữ liệu bao hàng nhập kho</div>
          </template>
        </v-autocomplete>
        <v-text-field
          v-if="currentItem.ID > 0"
          label="Mã bao hàng"
          v-model="currentItem.PackageCode"
          class="input-group--focused pt-0"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12  py-0 class="text--red">
        <v-autocomplete
          label="Kho TQ"
          class="input-group--focused pt-0"
          :items="chinaStores"
          v-model="currentItem.ChinaStoreID"
          item-text="Name"
          item-value="ID"
          @change="saveData"
        >
        </v-autocomplete>
      </v-flex>
      <v-flex lg4 sm12  py-0>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <v-text-field
          label="Ngày nhập kho"
          :value="currentItem.ImDate | display_date"
          class="input-group--focused font-weight-bold"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12  py-0>
        <h-currency-input
          label="Tổng phí ship"
          v-model="currentItem.Amount"
          :decimal="0"
          class="input-group--focused"
          readonly
        ></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12  py-0>
      </v-flex>
      <v-flex lg4 sm12  py-0>
        <h-currency-input
          label="Số kiện (TQ)"
          v-model="currentItem.Volume"
          :decimal="0"
          class="input-group--focused"
          @change="saveData"
        ></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <h-currency-input
          label="Số kiện đã nhập"
          v-model="currentItem.ReceivedPacks"
          :decimal="0"
          showClass="input-group--focused font-weight-bold text-red"
          color="red darken-2"
          readonly
        ></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <v-text-field
          label="Tổng cân nặng (TQ)"
          type="number"
          v-model="currentItem.Weight"
          class="input-group--focused"
          @change="saveData"
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <v-text-field
          label="Tổng cân nặng đã nhập"
          type="number"
          v-model="currentItem.ReceivedWeight"
          class="input-group--focused font-weight-bold text-red"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12 py-0>
      </v-flex>
      <v-flex lg8 sm12 py-0>
        <v-text-field
          label="Cân nặng thực tế"
          type="number"
          step=".1"
          v-model="currentItem.RealWeight"
          class="input-group--focused font-weight-bold"
          @change="saveData"
        ></v-text-field>
      </v-flex>
      <v-flex lg4 sm12 py-0>
      </v-flex>
      <v-flex lg4 sm12 py-0 class="text--red">
        <h-currency-input label="Giá cân NY" :decimal="0" v-model="currentItem.ListedFeeWeight" @press_enter="saveData" @on_blur="saveData"></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <h-currency-input label="Giá cân" :decimal="0" v-model="currentItem.FeeWeight" @press_enter="saveData" @on_blur="saveData"></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
      </v-flex>
      <v-flex lg4 sm12 py-0 class="text--red">
        <h-currency-input label="Giá khối NY" :decimal="0" v-model="currentItem.ListedFeeVolume" @press_enter="saveData" @on_blur="saveData"></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
        <h-currency-input label="Giá khối" :decimal="0" v-model="currentItem.FeeVolume" @press_enter="saveData" @on_blur="saveData"></h-currency-input>
      </v-flex>
      <v-flex lg4 sm12 py-0>
      </v-flex>
      <v-flex lg12 md12 sm12 py-0>
        <v-layout row wrap pa-3>
          <v-flex lg4 md4 sm12 py-0>
            <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
          </v-flex>
          <v-flex lg4 md4 sm12 py-0>
            <v-checkbox label="Nhập kho VN" v-model="importStore"></v-checkbox>
          </v-flex>
          <v-flex lg4 md4 sm12 py-0>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex lg12 md12 sm12 py-0>
        <v-text-field
          label="Mã vận đơn"
          ref="trancode"
          v-model.lazy="transactionCode"
          class="input-group--focused pt-0"
          @input="codeChanged"
          @keyup.enter="manualChanged"
          :disabled="readOnly"
        ></v-text-field>
      </v-flex>
      <v-flex lg12 md12 sm12 pa-0>
        <v-data-table
          :headers="headers"
          :items="currentItem.Packages"
          hide-default-footer
          disable-pagination
          :loading="loading"
          :mobile-breakpoint="100"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td v-bind:class="item.OrderID == null ? 'text-red' : ''">{{ item.TransactionCode }}</td>
              <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status)}}</td>
              <td><a target="blank" :href="(item.PackageType == 1 ? '/ky-gui/' : '/don-hang/') + item.OrderID">{{item.OrderID | pad(4,item.PackageType == 1 ? 'KG' : 'TB')}}</a></td>
              <td>{{ item.Username }}</td>
              <td class="text-end" v-if="item.Status == 5">{{ item.RealNumberOfPack}}</td>
              <td class="text-end" v-if="item.Status != 5">
                <v-edit-dialog
                  :return-value.sync="item.RealNumberOfPack"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight({ID: item.ID, RealNumberOfPack: item.RealNumberOfPack})"
                >
                  <div>{{ item.RealNumberOfPack}}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.RealNumberOfPack"
                      type="number"
                      label="Số kiện"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Weight}}</td>
              <td class="text-end" v-if="item.Status != 5">
                <v-edit-dialog
                  :return-value.sync="item.Weight"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight({ID: item.ID, Weight: item.Weight})"
                >
                  <div>{{ item.Weight}}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.Weight"
                      type="number"
                      label="Cân nặng"
                      step=".1"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Volume | currency('', 2)}}</td>
              <td class="text-end" v-else>
                <v-edit-dialog
                  :return-value.sync="item.Volume"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight({ID: item.ID, Volume: item.Volume})"
                >
                  <div>{{ item.Volume | currency('', 2) }}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.Volume"
                      step="0.01"
                      type="number"
                      label="Thể tích"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.ListedFeeWeight | currency }}</td>
              <td class="text-end" v-else>
                <v-edit-dialog
                  :return-value.sync="item.ListedFeeWeight"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight({ID: item.ID, ListedFeeWeight: item.ListedFeeWeight, FixListedFeeWeight: 1})"
                >
                  <div>{{ item.ListedFeeWeight | currency }}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.ListedFeeWeight"
                      step="1"
                      type="number"
                      label="Giá cân NY"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.ListedFeeVolume | currency }}</td>
              <td class="text-end" v-else>
                <v-edit-dialog
                  :return-value.sync="item.ListedFeeVolume"
                  large
                  lazy
                  persistent
                  @save="saveTranWeight({ID: item.ID, ListedFeeVolume: item.ListedFeeVolume, FixListedFeeWeight: 1})"
                >
                  <div>{{ item.ListedFeeVolume | currency }}</div>
                  <template v-slot:input>
                    <v-text-field
                      v-model="item.ListedFeeVolume"
                      step="1"
                      type="number"
                      label="Giá khối NY"
                      single-line
                      autofocus
                    ></v-text-field>
                  </template>
                </v-edit-dialog>
              </td>
              <td class="text-end">{{ item.ListedFeeWeightAmount | currency }}</td>
              <td class="truncate">
                <v-edit-dialog
                :return-value.sync="item.StoreVNNote"
                large
                lazy
                persistent
                @save="saveNoteItem(item)"
                >
                    <v-tooltip max-width="250" color="light-green lighten-5 black--text">
                        <template v-slot:activator="{ on }">
                            <span v-on="on">{{ item.StoreVNNote }}</span>
                        </template>
                        <span>{{ item.StoreVNNote }}</span>
                    </v-tooltip>
                    <template v-slot:input>
                        <v-textarea
                        v-model="item.StoreVNNote"
                        label="Ghi chú"
                        autofocus
                        ></v-textarea>
                    </template>
                </v-edit-dialog>
              </td>
              <td class="text-center">
                <v-icon medium class="mr-2" color="red darken-2" @click="printTransaction(item.ID, item.PackageType)">fa-print</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-overlay :value="appLoading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
     <v-dialog v-model="showDialogTrancode" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Mã vận đơn</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-text-field label="Mã vận đơn" v-model="newTransactionCode"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="showDialogTrancode = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="saveNewTrancode">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <upload-file :dialogUpload="dialogImport" title="Import mã vận đơn" temp_file="/nhap_kho_vn.xls" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import { print_transaction_v2, request_detail } from "@/commons/hpod";
import Vue from 'vue';
import { getCurrentTime, sendErrorNotice } from "@/commons/utils";
import upload_file from "@/components/popups/upload_file";
export default {
  components: {
        "upload-file": upload_file,
    },
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 20;
    
    return {
      appLoading: false,
      useBarcodeReader: false,
      importStore: false,
      transactionCode: "",
      package_status: configs.PACKAGE_STATUS,
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          values: configs.PACKAGE_STATUS,
          dataType: dataType["Enum"]
        },
        {
          text: "Order ID",
          value: "OrderID",
          quickSearch: true,
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          quickSearch: true,
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Số kiện",
          value: "RealNumberOfPack",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Khối",
          value: "Volume",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Giá cân NY",
          value: "ListedFeeWeight",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Giá khối NY",
          value: "ListedFeeVolume",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí VC NY",
          value: "ListedFeeWeightAmount",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ghi chú",
          value: "StoreVNNote",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [20, 30, 50] },
      currentTime: getCurrentTime(),
      showDialogTrancode: false,
      newTransactionCode: '',
      dialogImport: false
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    packageId() {
      if(this.packageId > 0) {
        this.$router.push({
        name: "StoreManagerVNDetail",
        params: {
          Pid: this.packageId,
          title: "Chi tiết nhập kho"
        }
      });
      this.refreshData();
      }
      this.appLoading = false;
    }
  },
  computed: {
    ...mapState({
      currentItem: state => state.bigPackage.selected,
      totalPackage: state => {
        state.bigPackage.selected.Packages
          ? state.bigPackage.selected.Packages.length
          : 0;
      },
      loading: state => state.bigPackage.loading,
      trancodeDetail: state => state.bigPackage.trancodeDetail,
      packages: state => state.bigPackage.notTransit,
      chinaStores: (state) => state.commons.chinaStores,
    }),
    packageId() {
      return this.currentItem && this.currentItem.ID > 0
        ? this.currentItem.ID
        : Number(this.$route.params.Pid);
    },
    trancode_param() {
      let configPaging = _.cloneDeep(configs.PAGINATION);
      var param = {
        pagination: {
          ...configPaging,
          itemsPerPage: 1000000
        },
        'trancode': this.transactionCode.trim() != '' ? this.transactionCode.trim() : ''
      };
      return param;
    }
  },
  mounted() {
    this.$store.dispatch("commons/getAllChinaStores");
    this.refreshData();
    this.getListPackageNotTran();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
    this.$root.$on("REQUEST_SAVE_DATA", this.dialogTrancode);
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_OTHER_ACTION", this.onImport);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.refreshData);
    this.$root.$off("REQUEST_SAVE_DATA", this.dialogTrancode);
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_OTHER_ACTION", this.onImport);
  },
  methods: {
    printTransaction(id, package_type) {
      request_detail('order_transactions/print', ret => {
          let item = ret.data;
          print_transaction_v2(item);
      }, Vue.http, id, this.$store.state.authentication.token, {'PackageType': package_type});
    },
    manualChanged() {
      if(!this.currentItem.ChinaStoreID && (!this.currentItem.ListedFeeWeight || !this.currentItem.ListedFeeVolume)) {
        sendErrorNotice("Hãy chọn kho TQ & giá niêm yết trước khi nhập kho!");
        return;
      }
      if (!this.useBarcodeReader) {
        if(this.importStore && this.transactionCode.trim() != '') {
          this.$store.dispatch("bigPackage/addNewTrancode", {'tran_code': this.transactionCode.trim(), 'package_id': this.packageId, 'only_update': true, 'param': this.trancode_param});
          this.transactionCode = '';
        }
        this.refreshData();
      }
    },
    codeChanged() {
      this.addNewTrancode();
    },
    addNewTrancode: _.debounce(
      function() {
        if(!this.currentItem.ChinaStoreID && (!this.currentItem.ListedFeeWeight || !this.currentItem.ListedFeeVolume)) {
          sendErrorNotice("Hãy chọn kho TQ & giá niêm yết trước khi nhập kho!");
          return;
        }
        if (this.useBarcodeReader) {
          if(this.importStore && this.transactionCode.trim() != '') {
            this.$store.dispatch("bigPackage/addNewTrancode", {'tran_code': this.transactionCode.trim(), 'package_id': this.packageId, 'param': this.trancode_param});
            this.transactionCode = '';
          }
          this.refreshData();
        }
      },
      1000,
      {
        leading: false,
        trailing: true
      }
    ),
    refreshData() {
      if (this.packageId) {
        this.$store.dispatch("bigPackage/getDetail", {'id': this.packageId, 'param': this.trancode_param});
      }
    },
    onChangePackage(value) {
      this.appLoading = true;
      let selectedItem = _.find(this.packages, { ID: value });
      if (selectedItem) {
        this.currentItem.PackageCode = selectedItem.PackageCode;
      }
      this.saveData();
    },
    getListPackageNotTran() {
      this.$store.dispatch("bigPackage/getListNotTransit");
    },
    saveTranWeight(item) {
      if(!this.currentItem.ChinaStoreID || (!this.currentItem.ListedFeeWeight && !this.currentItem.ListedFeeVolume)) {
        sendErrorNotice("Hãy nhập thông tin kho TQ và giá NY!");
        return;
      }
      this.editTransCode(item);
    },
    saveNoteItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {'data': {'StoreVNNote': item.StoreVNNote}, 'id': item.ID});
    },
    createData(username = "") {
      this.getListPackageNotTran();
      this.$store.commit("bigPackage/setDetail", {
        data: {
          ID: 0,
          PackageCode: '',
          Weight: 0,
          Volume: 0,
          Amount: 0
        }
      });
      this.$router.push({
          name: "StoreManagerVNDetail",
          params: {
          Pid: 'nhap-bao-moi',
          title: 'Nhập bao mới'
          }
      });
    },
    saveData() {
      this.$store.dispatch("bigPackage/setDetail", {
        data: {
          ReceivedWeight: this.currentItem.ReceivedWeight,
          RealWeight: this.currentItem.RealWeight,
          ReceivedPacks: this.currentItem.ReceivedPacks,
          ListedFeeWeight: this.currentItem.ListedFeeWeight,
          ListedFeeVolume: this.currentItem.ListedFeeVolume,
          FeeWeight: this.currentItem.FeeWeight,
          FeeVolume: this.currentItem.FeeVolume,
          ChinaStoreID: this.currentItem.ChinaStoreID,
          Volume: this.currentItem.Volume,
          Weight: this.currentItem.Weight,
        },
        id: this.currentItem.ID
      });
      this.appLoading = false;
    },
    editTransCode: _.debounce(
      function(item) {
        if(!this.currentItem.ChinaStoreID && (!this.currentItem.ListedFeeWeight || !this.currentItem.ListedFeeVolume)) {
          sendErrorNotice("Hãy chọn kho TQ & giá niêm yết trước khi nhập kho!");
          return;
        }
        var data = {
          ...item,
          BigPackageId: this.currentItem.ID,
          TransactionView: 'store_vn'
        };
        data.ModifiedBy = this.$store.state.authentication.user.username;
        this.$store.dispatch("orderTransaction/setDetail", { 'data': data, 'id': item.ID, 'param':  this.trancode_param});
      },
      500,
      {
        leading: false,
        trailing: true
      }
    ),
    dialogTrancode() {
      if(!this.currentItem.ID) {
        sendErrorNotice("Hãy chọn bao hàng nhập kho trước!");
        return;
      }
      this.showDialogTrancode = true;
    },
    saveNewTrancode() {
      if(!this.currentItem.ChinaStoreID && (!this.currentItem.ListedFeeWeight || !this.currentItem.ListedFeeVolume)) {
        sendErrorNotice("Hãy chọn kho TQ & giá niêm yết trước khi nhập kho!");
        return;
      }
      this.$store.dispatch("bigPackage/addNewTrancode", {'tran_code': this.newTransactionCode, 'package_id': this.packageId, 'param': this.trancode_param});
      this.newTransactionCode = '';
      this.showDialogTrancode = false;
    },
    onImport() {
      if(!this.currentItem.ID) {
        sendErrorNotice("Hãy chọn bao hàng nhập kho trước!");
        return;
      }
      this.dialogImport = true;
    },
    importFile(filelist) {
      for(const f of filelist) {
        const formData = new FormData();
        formData.append('excel_file', f);
        formData.append('filename', f.name);
        this.$store.dispatch("bigPackage/import_transaction", formData);
      }
      this.dialogImport = false;
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
  }
};
</script>
